import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import { retry, map, catchError } from 'rxjs/operators';
import 'rxjs/add/observable/throw';

import { ClassBookTemplate } from './class-book-template.model';
import { ClassBookTemplateInterface } from './class-book-template.interface';
import { ClassBookTemplateFactory } from './class-book-template.factory';
import { AuthService } from 'app/shared/auth/auth.service';
import { environment } from 'environments/environment';
import { GlobalService } from 'app/shared/global.service';

@Injectable()
export class ClassBookTemplateService {

    constructor(private http: HttpClient, private authService: AuthService, private globalService: GlobalService) { }

    getAll(params: HttpParams): Observable<Array<ClassBookTemplate>> {
        // params = params.append('token', localStorage.getItem('token'));
        return this.http
            // tslint:disable-next-line:max-line-length
            .get<ClassBookTemplateInterface[]>(`${environment.apiUrl}/v${environment.apiVersion}/class-book-templates`, { params, headers: this.authService.headers() })
            .pipe(map(data => data
                .map(item => ClassBookTemplateFactory.fromObject(item)),
            ), catchError(this.errorHandler));
    }

    getSingle(id: string): Observable<ClassBookTemplate> {
        return this.http
            // tslint:disable-next-line:max-line-length
            .get<ClassBookTemplateInterface>(`${environment.apiUrl}/v${environment.apiVersion}/class-book-templates/${id}`, { headers: this.authService.headers() })
            .pipe(map(item => ClassBookTemplateFactory.fromObject(item)),
                catchError(this.errorHandler)
            );
    }

    createOrUpdate(classBookTemplate: ClassBookTemplate): Observable<any> {
        if (classBookTemplate.id) {
            return this.http
                // tslint:disable-next-line:max-line-length
                .put(`${environment.apiUrl}/v${environment.apiVersion}/class-book-templates/${classBookTemplate.id}`, classBookTemplate, { responseType: 'text', headers: this.authService.headers() })
                .pipe(
                    map(item => JSON.parse(item)),
                    catchError(this.errorHandler)
                );
        }
        return this.http
            // tslint:disable-next-line:max-line-length
            .post(`${environment.apiUrl}/v${environment.apiVersion}/class-book-templates`, classBookTemplate, { responseType: 'text', headers: this.authService.headers() })
            .pipe(
                map(item => JSON.parse(item)),
                catchError(this.errorHandler)
            );
    }

    remove(id: string): Observable<any> {
        return this.http
            .delete(`${environment.apiUrl}/v${environment.apiVersion}/class-book-templates/${id}`, { headers: this.authService.headers() })
            .pipe(
                catchError(this.errorHandler)
            );
    }

    /*remove(isbn: string): Observable<any> {
        return this.http
            .delete(`${this.api}/class-book-template/${isbn}`, { responseType: 'text', headers: this.authService.headers() })
            .pipe(
                catchError(this.errorHandler)
            );
    }
 */

    private errorHandler(error: Error | any): Observable<any> {
        // this.globalService.handleError(error);
        console.error('handleError', error)
        return Observable.throw(error);
    }

    /* getAllSearch(searchTerm: string): Observable<Array<ClassBookTemplate>> {
        return this.http
            .get<ClassBookTemplateInterface[]>(`${this.api}/class-book-templates/search/${searchTerm}`)
            .pipe(
                retry(3),
                map(rawCategories => rawCategories
                    .map(rawClassBookTemplate => ClassBookTemplateFactory.fromObject(rawClassBookTemplate)),
                ),
                catchError(this.errorHandler)
            );
    } */
}



// WEBPACK FOOTER //
// ./src/app/settings/class-book-templates/shared/class-book-template.service.ts